import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { DateTimeService } from '../date-time.service';
import { fade } from '../shared/animations';
import { QuoteService } from './quote.service';

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.scss'],
  animations: [fade]
})
export class QuoteComponent implements OnInit, OnDestroy {
  quoteSubscription: Subscription;
  summaryDetail;
  price;
  prefixTime: string;
  delayedState: string;
  nameDivider = '&nbsp;|&nbsp;';
  priceDivider = '&nbsp;&nbsp;&nbsp;';
  ready;

  constructor(
    private quoteService: QuoteService,
    public dtService: DateTimeService
  ) { }

  ngOnInit(): void {
    this.quoteSubscription = this.quoteService.quoteSubject$
      .pipe(map((res: any) => {
        const price = res[0].quoteSummary.result[0].price;
        const summaryDetail = res[1].quoteSummary.result[0].summaryDetail;
        price.asOfTime = this.dtService.convertFilingTimeShort(new Date(price.regularMarketTime * 1000));
        const priceFmt = this.getPriceFmt(price);
        price.regularMarketChange.fmt = priceFmt.prepend + (+price.regularMarketChange.fmt).toFixed(2);
        price.regularMarketChangePercent.fmt = priceFmt.prepend + price.regularMarketChangePercent.fmt;
        price.regularMarketPrice.fmt = (+price.regularMarketPrice.fmt).toFixed(2);

        if (!summaryDetail.bidSize.fmt) {
          summaryDetail.bidSize.fmt = '0';
        }
        if (!summaryDetail.askSize.fmt) {
          summaryDetail.askSize.fmt = '0';
        }

        switch (price.marketState) {
          case 'PREPRE':
          case 'PRE':
            this.prefixTime = 'At close: ';
            this.delayedState = 'Real Time Price.';
            break;

          default:
            this.prefixTime = 'As of: ';
            this.delayedState = price.quoteSourceName + '.';
            break;
        }
        return { price, summaryDetail };
      }))
      .subscribe(res => {
        this.price = res.price;
        this.summaryDetail = res.summaryDetail;
        setTimeout(() => {
          this.ready = true;
        }, 100);
        // console.log('price: ', this.price);
        // console.log('summaryDetail: ', this.summaryDetail);
      });
  }

  refreshQuote() {
    this.quoteService.getQuote(this.price.symbol);

  }
  getPriceFmt(price) {
    let prepend;
    let color;
    switch (Math.sign(+price.regularMarketChange.fmt)) {
      case 1:
        prepend = '+';
        color = 'green';
        break;
      case -1:
        prepend = '';
        color = 'red';
        break;
      default:
        prepend = '';
        break;
    }
    return { prepend, color };
  }

  symbolClicked(symbol: string) {
    window.open(`https://finance.yahoo.com/quote/${symbol}`, '_blank');
  }

  ngOnDestroy() {
    if (this.quoteSubscription) {
      this.quoteSubscription.unsubscribe();
    }
  }

}
